import { render, staticRenderFns } from "./memuSetting.vue?vue&type=template&id=028027ef&scoped=true&"
import script from "./memuSetting.vue?vue&type=script&lang=js&"
export * from "./memuSetting.vue?vue&type=script&lang=js&"
import style0 from "./memuSetting.vue?vue&type=style&index=0&id=028027ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028027ef",
  null
  
)

export default component.exports